import { Components, Theme } from '@mui/material/styles';

export default function MuiDialogActions(theme: Theme): Components['MuiDialogActions'] {
  return {
    styleOverrides: {
      root: {
        justifyContent: 'center',
        paddingLeft: '56px',
        paddingRight: '56px',
      },
    },
  };
}
